// extracted by mini-css-extract-plugin
export default {"imgFrame":"UiVideo_imgFrame_sgABH"};